import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "call-to-action" }
const _hoisted_2 = { href: "https://spenden.wikimedia.de" }

interface Props {
	text: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'CallToAction',
  props: {
    text: {}
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("a", _hoisted_2, _toDisplayString(__props.text), 1)
  ]))
}
}

})